import { makeStyles, Theme } from "@material-ui/core";

type modalBaseStyleProps = { maxWidth?: string };
const useModalBaseStyles = makeStyles((theme: Theme) => ({
	root: (props: modalBaseStyleProps) => ({
		maxWidth: props.maxWidth ?? "600px",
		borderRadius: "0",
	}),
	title: {
		paddingTop: "16px",
		paddingBottom: "16px",
	},
	iconBox: {
		padding: 0,
	},
	icon: {
		color: "#000000",
	},
	content: {
		paddingTop: 0,
		paddingBottom: 0,
		overflow: "visible",
	},
	actions: {
		paddingLeft: "24px",
		paddingRight: "24px",
	},
	gridItem: {
		[theme.breakpoints.only("xs")]: {
			width: "100%",
		},
	},
}));
export default useModalBaseStyles;
